// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__14bIv","insightsList":"newBusinessInsightsMenu_insightsList__2khhX","active":"newBusinessInsightsMenu_active__2swkl"};